import type { FC } from "react"

import { InformationMissingAlert } from "@/components/common/Alerts/InformationMissingAlert"

interface ProductSelectionWipPanelProps {
  tabLabel: string
}

export const ProductSelectionWipPanel: FC<ProductSelectionWipPanelProps> = ({ tabLabel }) => (
  <InformationMissingAlert title={`${tabLabel} products are coming soon`} />
)
